<script>
    import Layout from "../../layouts/main";
    import PageHeader from "@/components/page-header";
    import appConfig from "@/app.config";
    import countTo from "vue-count-to";

    import DatePicker from "vue2-datepicker";
    import moment from "moment";
    import Merchandising from "@/services/Merchandising";

    /**
     * Orders component
     */
    export default {
        components: { Layout, PageHeader,DatePicker,countTo},
        page: {
            title: "POD Report",
            meta: [
                {
                    name: "description",
                    content: appConfig.description,
                },
            ],
        },
        data() {
            return {
                title: "POD Report",
                items: [
                    {
                        text: "Merchandising",
                    },
                  {
                        text: "POD Report ",
                        active: true,
                    },
                ],
                filterInput: {
                    from_date: '',
                    to_date: '',
                },



                isBusy: false,
                guid: '',
                showDateInfo: true,

                tableData: [],
                totalRows: 1,
                currentPage: 1,
                reportTotals: [],
                perPage: 10,
                pageOptions: [10, 25, 50, 100],

                missingCostsTableData: [],
                missingCostsTotalRows: 1,
                missingCostsPerPage: 10,
                missingCostsCurrentPage: 1,
                missingCostsPageOptions: [10, 25, 50, 100],

                filter: null,
                filterMissing:null,
                filterOn: [],
                selectedOrderType: null,
                loadingTotals:true,
                isInitialLoad: true,
                sortBy: "created_gmt",
                sortDesc: true,
                fields: [
                    {
                        key: "product_id",
                        label: "Product ID",
                    },
                    {
                        key: "variation_id",
                        label: "Variation ID",
                    },
                    {
                      key: "product_title",
                      label: "Product",
                    },
                    {
                      key: "variant_title",
                      label: "Variant",
                    },

                    {
                      key: "quantity_purchased",
                      label: "Quantity",
                    },
                    {
                      key: "price",
                      label: "Total Price",
                    },
                    {
                      key: "purchase",
                      label: "Total Price ex. VAT",
                    },
                    {
                      key: "costs",
                      label: "Costs",
                    },
                    {
                      key: "difference",
                      label: "Difference",
                    },
                ],
                  missingCostsFields: [
                    {
                      key: "product_id",
                      label: "Product ID",
                    },

                    {
                      key: "variation_id",
                      label: "Variation ID",
                    },
                    {
                      key: "description",
                      label: "Description",
                    },
                    {
                      key: "price",
                      label: "Price",
                    },
                    {
                      key: "qty",
                      label: "Quantity",
                    },
                    {
                      key: "order_paid",
                      label: "Paid",
                    },
                    {
                      key: "order_status",
                      label: "Status",
                    },
                    {
                      key: "order_created",
                      label: "Created",
                    }
                ],
            };
        },

        middleware: "authentication",
        computed: {


            dynamicDateInfo() {

                // On initial load, show default text
                if (this.isInitialLoad) {
                    return 'Data from the last 30 days';
                }

                const today = new Date();
                const startDate = this.filterInput.from_date ? new Date(this.filterInput.from_date) : null;
                const endDate = this.filterInput.to_date ? new Date(this.filterInput.to_date) : null;


                if (startDate || endDate) {
                    const startStr = startDate.toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' });
                    const endStr = endDate.toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' });
                    
                    if (startStr === endStr) {
                        return `Data from ${startStr}`;
                    } else {
                        return `Data from ${startStr} to ${endStr}`;
                    }
                }
                
                return 'Data from the last 30 days';
            }
        },
        async created() {
            const today = new Date();
            const thirtyDaysAgo = new Date();
            thirtyDaysAgo.setDate(today.getDate() - 30);
            this.filterInput.from_date = thirtyDaysAgo.toISOString().split("T")[0];
            this.filterInput.to_date = today.toISOString().split("T")[0];
            await this.getPODReport()
        },
        methods: {
            filterData(){
              this.isInitialLoad = false;
              this.getPODReport()
            },

            rowClass(item, type) {
              if (!item) return '';

              if (item.costs === null) {
                return 'bg-danger';
              }
              return '';
            },
            async getPODReport(){
                try {
                    this.loadingTotals = true;
                    this.toggleBusy();
                    let filters = this.getFilters();
                    const response = await Merchandising.getPODReport(filters);
                    this.reportTotals = response.data.data.totals;
                    this.missingCostsTableData = response.data.data.pod_missing_cost;
                    this.tableData = response.data.data.rows;
                    this.totalRows = this.tableData.length;
                    this.missingCostsTotalRows = this.missingCostsTableData.length;
                    this.loadingTotals = false;
                    this.toggleBusy();
                } catch (error) {
                    this.toggleBusy();
                    this.error = error.response.data.error ? error.response.data.error : "";
                    this.tableData = []
                    this.totalRows =1
                    this.missingCostsTableData = [];
                    this.missingCostsTotalRows = 1;
                    this.loadingTotals = false;
                }
            },

            exportPODReport() {
              // Create CSV content
              const headers = ['Product ID', 'Product Title', 'Purchase', 'Quantity Purchased', 'Costs', 'Difference'];
              const csvContent = [
                headers.join(','),
                ...this.tableData.map(product => [
                  product.product_id,
                  product.product_title || '',
                  product.purchase || '',
                  product.quantity_purchased || '0',
                  product.costs || '',
                  product.difference || ''
                ].join(','))
              ].join('\n');
              
              // Download CSV
              const blob = new Blob([csvContent], { type: 'text/csv' });
              const url = window.URL.createObjectURL(blob);
              const a = document.createElement('a');
              a.href = url;
              a.download = `pod_report_${new Date().toISOString().split('T')[0]}.csv`;
              a.click();
              window.URL.revokeObjectURL(url);
            },

           getFilters(){
              var filter_string = '&type=pod_products';
              if(this.filterInput.from_date) {
                filter_string += (this.filterInput.from_date) ? '&date_from=' + moment(this.filterInput.from_date).format('YYYY-MM-DD') : "";
              }
              if(this.filterInput.to_date) {
                filter_string += (this.filterInput.to_date) ? '&date_to=' + moment(this.filterInput.to_date).format('YYYY-MM-DD') : "";
              }
              return filter_string = filter_string.substring(1);
            },



            /**
             * Search the table data with search input
             */
            onFiltered(filteredItems) {
                // Trigger pagination to update the number of buttons/pages due to filtering
                this.totalRows = filteredItems.length;
                this.currentPage = 1;
            },

            resetFilters() {
              const today = new Date();
              const thirtyDaysAgo = new Date();
              thirtyDaysAgo.setDate(today.getDate() - 30);
              this.filterInput.from_date = thirtyDaysAgo.toISOString().split("T")[0];
              this.filterInput.to_date = today.toISOString().split("T")[0];
              this.isInitialLoad = true;
              this.getPODReport();
            }
        },
    };
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
      <div class="row">
        <div class="col-12">

          <div class="card">
            <div class="card-body">

              <div class="row mt-4">
                <div class="col-md-12">
                  <div class="custom-accordion">
                    <a
                        class="text-body fw-semibold pb-2 d-block"
                        data-toggle="collapse"
                        href="javascript: void(0);"
                        role="button"
                        aria-expanded="false"
                        v-b-toggle.categories-collapse
                    >
                      <i class="mdi mdi-chevron-up accor-down-icon text-primary me-1"></i>Filters
                    </a>
                    <b-collapse visible id="categories-collapse">
                      <div class="card shadow-none">
                        <div class="row">


                          <!-- Start Date -->
                          <div class="col-sm-12 col-md-3">
                            <b-form-group label="Start Date" label-for="formrow-from_date-input" class="mb-3">
                              <date-picker
                                  v-model="filterInput.from_date"
                                  append-to-body
                                  lang="en"
                                  confirm
                                  format="YYYY-MM-DD"
                              ></date-picker>
                            </b-form-group>
                          </div>

                          <!-- End Date -->
                          <div class="col-sm-12 col-md-3">
                            <b-form-group label="End Date" label-for="formrow-to_date-input" class="mb-3">
                              <date-picker
                                  v-model="filterInput.to_date"
                                  append-to-body
                                  lang="en"
                                  confirm
                                  format="YYYY-MM-DD"
                              ></date-picker>
                            </b-form-group>
                          </div>
                        </div>

                        <div class="row">
                          <div class="col d-inline-flex gap-2">
                            <button type="button" class="btn btn-success" @click="filterData">
                              <i class="mdi mdi-filter me-1"></i>Filter
                            </button>
                            <button type="button" class="btn btn-outline-primary" @click="resetFilters">
                              <i class="mdi mdi-refresh me-1"></i>Reset
                            </button>
                            <button type="button" class="btn btn-outline-success" @click="exportPODReport"
                                    :disabled="tableData.length === 0">
                              <i class="mdi mdi-download me-1"></i>Export CSV
                            </button>
                          </div>
                        </div>
                      </div>
                    </b-collapse>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="loadingTotals" class="d-flex align-items-center justify-content-center mb-3">
            <b-spinner large class="me-2 text-success"/>
          </div>
          <div class="row mb-3 mt-3" v-else>
            <h4>{{dynamicDateInfo}}</h4>

            <div class="col-md-6 col-xl-4">
              <div class="card">
                <div class="card-body">
                  <div>
                    <h1 class="mb-1 mt-1 text-success">
                                <span data-plugin="counterup">
                                    <countTo :startVal="0" :decimals='2' :endVal="reportTotals.purchase"
                                             :duration="1000"></countTo>
                                </span>
                    </h1>
                    <p class="mb-0" style="font-size: x-large;">Revenue</p>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-6 col-xl-4">
              <div class="card">
                <div class="card-body">
                  <div>
                    <h1 class="mb-1 mt-1 text-success">
                                <span data-plugin="counterup">
                                    <countTo :startVal="0" :decimals='2' :endVal="reportTotals.costs"
                                             :duration="1000"></countTo>
                                </span>
                    </h1>
                    <p class="mb-0" style="font-size: x-large;">Costs</p>
                  </div>
                </div>
              </div>
            </div>


            <div class="col-md-6 col-xl-4">

              <div class="card">
                <div class="card-body">
                  <div>
                    <h1 class="mb-1 mt-1 text-success">
                                <span data-plugin="counterup">
                                    <countTo :startVal="0" :decimals='2' :endVal="reportTotals.difference"
                                             :duration="1000"></countTo>
                                </span>
                    </h1>
                    <p class="mb-0" style="font-size: x-large;">Difference</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="card">
            <div
                class="table table-centered datatable dt-responsive nowrap table-card-list dataTable no-footer dtr-inline">
              <div class="row">
                <div class="col-sm-12 col-md-6">
                  <div id="tickets-table_length" class="dataTables_length">
                    <label class="d-inline-flex align-items-center fw-normal">
                      Show&nbsp;
                      <b-form-select
                          v-model="perPage"
                          size="sm"
                          :options="pageOptions"
                      ></b-form-select
                      >&nbsp;entries
                    </label>
                  </div>
                </div>
                <!-- Search -->
                <div class="col-sm-12 col-md-6">
                  <div
                      id="tickets-table_filter"
                      class="dataTables_filter text-md-end"
                  >
                    <label class="d-inline-flex align-items-center fw-normal">
                      Search:
                      <b-form-input
                          v-model="filter"
                          type="search"
                          placeholder="Search..."
                          class="form-control form-control-sm ms-2"
                      ></b-form-input>
                    </label>
                  </div>
                </div>
                <!-- End search -->
              </div>
              <!-- Table -->

              <b-table
                  table-class="table-responsive mb-0"
                  :busy="isBusy"
                  :items="tableData"
                  :fields="fields"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  :filter="filter"
                  :tbody-tr-class="rowClass"
                  :filter-included-fields="filterOn"
                  sort-icon-left
                  @filtered="onFiltered"
                  show-empty
                  empty-text="No orders found for the selected criteria"
              >
                <template #table-busy>
                  <div class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Loading...</strong>
                  </div>
                </template>

                <template #empty>
                  <div class="text-center py-4">
                    <i class="mdi mdi-package-variant-closed font-size-48 text-muted"></i>
                    <h5 class="mt-2">No Products Found</h5>
                    <p class="text-muted">No products found for the selected criteria. Try adjusting your filters.</p>
                  </div>
                </template>
                <template v-slot:cell(costs)="data">
                  <span :class="data.item.costs === 0 ? 'badge bg-danger' : ''">{{ data.item.costs }}</span>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded">
                    <!-- pagination -->
                    <b-pagination
                        v-model="currentPage"
                        :total-rows="totalRows"
                        :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
            <div class="p-3">
              <h3>POD Missing Costs</h3>
              <span v-if="missingCostsTableData.length" class="text-danger">Missing cost for following products/variations. Please fix this to generate a more accurate report.</span>
            </div>
            <div
                class="table table-centered datatable dt-responsive nowrap table-card-list dataTable no-footer dtr-inline">
              <div class="row">
                <div class="col-sm-12 col-md-6">
                  <div id="tickets-table_length" class="dataTables_length">
                    <label class="d-inline-flex align-items-center fw-normal">
                      Show&nbsp;
                      <b-form-select
                          v-model="missingCostsPerPage"
                          size="sm"
                          :options="missingCostsPageOptions"
                      ></b-form-select
                      >&nbsp;entries
                    </label>
                  </div>
                </div>
                <!-- Search -->
                <div class="col-sm-12 col-md-6">
                  <div
                      id="tickets-table_filter"
                      class="dataTables_filter text-md-end"
                  >
                    <label class="d-inline-flex align-items-center fw-normal">
                      Search:
                      <b-form-input
                          v-model="filterMissing"
                          type="search"
                          placeholder="Search..."
                          class="form-control form-control-sm ms-2"
                      ></b-form-input>
                    </label>
                  </div>
                </div>
                <!-- End search -->
              </div>
              <!-- Table -->

              <b-table
                  table-class="table-responsive mb-0"
                  :busy="isBusy"
                  :items="missingCostsTableData"
                  :fields="missingCostsFields"
                  responsive="sm"
                  :per-page="missingCostsPerPage"
                  :current-page="missingCostsCurrentPage"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  :filter="filterMissing"
                  :filter-included-fields="filterOn"
                  sort-icon-left
                  @filtered="onFiltered"
                  show-empty
                  empty-text="No orders found for the selected criteria"
              >
                <template #table-busy>
                  <div class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Loading...</strong>
                  </div>
                </template>

                <template #empty>
                  <div class="text-center py-4">
                    <i class="mdi mdi-package-variant-closed font-size-48 text-muted"></i>
                    <h5 class="mt-2">No Missing Costs Found</h5>
                    <p class="text-muted">No missing costs found for the selected criteria. Try adjusting your
                      filters.</p>
                  </div>
                </template>
                <!--                  <template v-slot:cell(costs)="data">-->
                <!--                    <span :class="data.item.costs === 0 ? 'badge bg-danger' : ''">{{data.item.costs}}</span>-->
                <!--                  </template>-->

              </b-table>
            </div>

            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded">
                    <!-- pagination -->
                    <b-pagination
                        v-model="missingCostsCurrentPage"
                        :total-rows="missingCostsTotalRows"
                        :per-page="missingCostsPerPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>

          </div>


        </div>
      </div>
    </Layout>
</template>
<style>

</style>
